export default __webpack_public_path__ + "static/media/17.02d9758b.gif";